import React from "react";
import { Grid, Typography, CardHeader, CardContent } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { ChartCard } from "../Style/health-chart.style";

export default function DistrictWiseHTNDMChart({ selectedDistrict, allDistrictsChartData }) {
    // Prepare HTN/DM/Others data
    const chartData = selectedDistrict === 'ALL'
        ? allDistrictsChartData.map(d => ({
            district: d.DISTRICT,
            htn: Number(d.count_htn || 0),
            dm: Number(d.count_dm || 0),
            others: Number(d.OTHER || 0)
        }))
        : [{
            district: selectedDistrict,
            htn: Number(allDistrictsChartData.find(d => d.DISTRICT === selectedDistrict)?.count_htn || 0),
            dm: Number(allDistrictsChartData.find(d => d.DISTRICT === selectedDistrict)?.count_dm || 0),
            others: Number(allDistrictsChartData.find(d => d.DISTRICT === selectedDistrict)?.OTHER || 0)
        }];

    // Sort by total ascending
    const sortedChartData = chartData.sort((a, b) =>
        (a.htn + a.dm + a.others) - (b.htn + b.dm + b.others)
    );

    return (
        <Grid item xs={12} md={6} sx={{ width: "1020px" }}>
            <ChartCard>
                <CardHeader
                    title={
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", fontSize: "14px", textAlign: 'center', textDecorationLine: 'underline' }}
                        >
                            District Wise HTN/DM/Other Disease
                        </Typography>
                    }
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <BarChart
                        xAxis={[{ scaleType: "linear" }]}
                        yAxis={[
                            {
                                width: 100,
                                scaleType: "band",
                                data: sortedChartData.map(item => item.district),
                                tickLabelStyle: { fontSize: 12 },
                            },
                        ]}
                        series={[
                            {
                                data: sortedChartData.map(item => item.htn),
                                label: "HTN",
                                color: "#1976d2",
                            },
                            {
                                data: sortedChartData.map(item => item.dm),
                                label: "DM",
                                color: "#388e3c",
                            },
                            {
                                data: sortedChartData.map(item => item.others),
                                label: "Others",
                                color: "#fbc02d",
                            },
                        ]}
                        layout="horizontal"
                        height={425}
                        slotProps={{
                            legend: {
                                direction: "horizontal",
                                position: { horizontal: "center", vertical: "bottom" },
                            },
                        }}
                    />
                </CardContent>
            </ChartCard>
        </Grid>
    );
}
